export { default } from './DragSlider';
